/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { CustomModal, CustomText, CustomTitle, Loader } from 'src/components'

interface CartConfirmModalProps {
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
}


const CartConfirmModal: React.FC<CartConfirmModalProps> = ({ isModalVisible, setIsModalVisible }) => {
  const { t } = useTranslation()
  const [infoToUser, setInfoToUser] = useState('')
  const [infoToUserTitle, setInfoToUserTitle] = useState('')

  useEffect(() => { setTimeout(showFirstText) }, [])

  const showFirstText = () => {
    setInfoToUserTitle(t('developers.InfoToUser.TransactionDataTitle'))
    setInfoToUser(t('developers.InfoToUser.TransactionData'))
    setTimeout(
      showSecondText,
      11000
    )
  }

  const showSecondText = () => {
    setInfoToUserTitle(t('developers.InfoToUser.TransactionBeingVerifiedTitle'))
    setInfoToUser(t('developers.InfoToUser.TransactionBeingVerified'))
    setTimeout(
      showThirdText,
      11000
    )
  }

  const showThirdText = () => {
    setInfoToUserTitle(t('developers.InfoToUser.TransactionCertificateTitle'))
    setInfoToUser(t('developers.InfoToUser.TransactionCertificate'))
  }


  return <CustomModal
    footer={null}
    open={isModalVisible}
    closable={false}
    onCancel={() => setIsModalVisible(false)}
    maskClosable={false}
  >
    <div className='content has-text-centered'>
      <Loader />
    </div>

    <div className='content has-text-centered'>
      <CustomTitle
        type={null}
        label={infoToUserTitle}
        className='has-text-weight-bold title'
      />
    </div>

    <div className='content has-text-centered'>
      <CustomText label={infoToUser}/>
    </div>
  </CustomModal>
}
export default CartConfirmModal
